<template>
    <BaseModal title="" @close="closeModal" :visible="true" size="small" customClass="assessment__confirmation__popup">
        <div class="popup__content__box">
            <div class="popup__img__wrapperb rlms-mb-4">
                <img :src="zeroPointIcon" class="rlms-mx-auto" />
            </div>
            <div class="confirmation__text__box rlms-mb-4 rlms-gap-0">
                <h4 class="popup__title">Automatic Scoring Adjustment</h4>
                <div class="description__wrapper">
                    <p>Five consecutive 0 scores in Group {{ group }} reached the ceiling, so this group stops here.
                        {{ ceilingScopeText(group) }} ({{ CEILING_RULE_REF }})</p>
                </div>
            </div>
        </div>
        <div class="popup__btn__box">
            <div class="purple__solid__btn">
                <a id="scoreZero" href="javascript:void(0);" @click="saved">OK</a>
            </div>
        </div>
    </BaseModal>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import BaseModal from '../BaseModal.vue';
import { handleError } from '@/utils/handleError';
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import zeroPointIcon from '@/assets/images/zero-point.png';
import { ceilingScopeText, CEILING_RULE_REF } from '@/utils/assessment-ceiling';

const props = defineProps({
    organizationId: Number,
    assessmentId: Number,
    group: Number,
    lastAttemptId: Number,
});

// eslint-disable-next-line
const emit = defineEmits(['close', 'saved']);

const showModal = ref(true);

const loader = useLoaderStore();

const closeModal = () => {
    showModal.value = false;
    emit('close');
};

const saved = () => {
    closeModal();
}

const attemptZero = async () => {
    try {
        loader.show();

        await api.post(
            `/organizations/${props.organizationId}/assessments/${props.assessmentId}/attempt-zero-point`,
            {
                group: props.group,
                lastAttemptId: props.lastAttemptId
            },
        );
        
        emit('saved');
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

onMounted(() => attemptZero());
</script>
